import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

export const SUPPLIER_TYPES = [
  { value: 'fuel',      label: 'Fuel Station' },
  { value: 'parts',     label: 'Parts Supplier' },
  { value: 'service',   label: 'Service Provider' },
  { value: 'tyres',     label: 'Tyre Supplier' },
  { value: 'insurance', label: 'Insurance' },
  { value: 'general',   label: 'General' },
];

const SupplierFormFields = ({
  isEdit,
  formData,
  onFieldChange,
  onSubmit,
  onCancel,
  saving,
}) => (
  <form onSubmit={onSubmit} className="space-y-4">
    <div className="grid grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label>Supplier Name *</Label>
        <Input
          value={formData.name}
          onChange={(e) => onFieldChange('name', e.target.value)}
          placeholder="e.g., Shell Garage"
          data-testid="supplier-name-input"
        />
      </div>
      <div className="space-y-2">
        <Label>Supplier Type *</Label>
        <Select
          value={formData.supplier_type}
          onValueChange={(value) => onFieldChange('supplier_type', value)}
        >
          <SelectTrigger data-testid="supplier-type-select">
            <SelectValue placeholder="Select type" />
          </SelectTrigger>
          <SelectContent>
            {SUPPLIER_TYPES.map((type) => (
              <SelectItem key={type.value} value={type.value}>{type.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
    <div className="grid grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label>Contact Person</Label>
        <Input
          value={formData.contact_person}
          onChange={(e) => onFieldChange('contact_person', e.target.value)}
          placeholder="John Smith"
          data-testid="supplier-contact-input"
        />
      </div>
      <div className="space-y-2">
        <Label>Phone Number</Label>
        <Input
          value={formData.phone}
          onChange={(e) => onFieldChange('phone', e.target.value)}
          placeholder="+27 12 345 6789"
          data-testid="supplier-phone-input"
        />
      </div>
    </div>
    <div className="grid grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label>Email</Label>
        <Input
          type="email"
          value={formData.email}
          onChange={(e) => onFieldChange('email', e.target.value)}
          placeholder="supplier@example.com"
          data-testid="supplier-email-input"
        />
      </div>
      <div className="space-y-2">
        <Label>Account Number</Label>
        <Input
          value={formData.account_number}
          onChange={(e) => onFieldChange('account_number', e.target.value)}
          placeholder="ACC-001234"
          className="font-data"
          data-testid="supplier-account-input"
        />
      </div>
    </div>
    <div className="space-y-2">
      <Label>Address</Label>
      <Input
        value={formData.address}
        onChange={(e) => onFieldChange('address', e.target.value)}
        placeholder="123 Main Road, Cape Town"
        data-testid="supplier-address-input"
      />
    </div>
    <div className="space-y-2">
      <Label>Payment Terms</Label>
      <Input
        value={formData.payment_terms}
        onChange={(e) => onFieldChange('payment_terms', e.target.value)}
        placeholder="e.g., 30 days, COD"
        data-testid="supplier-terms-input"
      />
    </div>
    <div className="space-y-2">
      <Label>Notes</Label>
      <Textarea
        value={formData.notes}
        onChange={(e) => onFieldChange('notes', e.target.value)}
        placeholder="Additional notes..."
        rows={2}
        data-testid="supplier-notes-input"
      />
    </div>
    <div className="flex justify-end gap-2 pt-4">
      <Button type="button" variant="outline" onClick={onCancel}>Cancel</Button>
      <Button type="submit" disabled={saving} data-testid="save-supplier-btn">
        {saving ? 'Saving...' : (isEdit ? 'Update Supplier' : 'Add Supplier')}
      </Button>
    </div>
  </form>
);

export default SupplierFormFields;
